import store from '../../init/store.js'
import {getQueryVariable} from '../../helpers/get-query-variable.js'

/** Look up a user's data */
export async function getUserDataFromFirebase(userId) {
  const userDataSnapshot = await window.firebase.database().ref(`users/${userId}`).once("value");
  return userDataSnapshot.val();
}

/** Set user data */
export function setUserDataInFirebase(userId, payload) {
  window.firebase.database().ref(`users/${userId}`).update(payload);
}

/** Set user crewMembers */
export function setUserCrewMemberInFirebase(crewData) {

  let user = window.firebase.auth().currentUser;
  if (user) {
    // User is signed in.
    //Set crewMembers and crewName
    window.firebase.database().ref(`users/client_${user.uid}`).child('crewMembers').set(crewData);
  } else {
    // No user is signed in.
  }

}

/** Set user Crew name */
export function setUserCrewName() {

  let user = window.firebase.auth().currentUser;
  if (user) {
    // User is signed in.
    //Set crewMembers and crewName
    window.firebase.database().ref(`users/client_${user.uid}`).child('crewName').set(store.getState().crew.name);
  } else {
    // No user is signed in.
  }

}

export const userRecordsSchema = {
  quickBattleWins: 0,
  quickBattleLosses: 0,

  fullteamBattleWins: 0,
  fullteamBattleLosses: 0,

  openBattleWins: 0,
  openBattleLosses: 0,
};

/** Get result my user results */
export function getUserRecord(callback) {

  const localData = store.getState().crew.record; //Start with local data, then merge in truth from Firebase (if we're logged in)

  let user = window.firebase.auth().currentUser;

    if (user) { // User is signed in.
      //Get my battle record.
      const userRef = window.firebase.database().ref(`users/client_${user.uid}`).child('battleRecord');
      userRef.once("value", snap => {
        const userRecord = snap.val() || {};

        //Fire the callback with the user's data. Merge in the defaults if no record exists.
        callback({
          ...userRecordsSchema,
          ...localData,
          ...userRecord
        })
      })
    } else {
      // No user is signed in. Return the basic schema.
      //TODO: this is misleading. This will always return a blank record even if you've managed to do a few battles without logging in.
      //The big question: Do we log you in when you finish a battle? If so, everybody should be logged in, and this would be a mega response-timeout edge case
      callback({
        ...userRecordsSchema,
        ...localData,
      })
    }

}

//winOrLose: "win" | "lose"
//battleType: "quick" | "fullteam" | "open"
export function updateUserRecord(existingRecord, winOrLose = "", battleType = "", callback) {

  let editingKey = getEditingRecordKey(winOrLose, battleType);
  const newRecord = {
    ...existingRecord,
    [editingKey]: existingRecord[editingKey] !== "undefined" ? existingRecord[editingKey] + 1 : 0 //Augment whatever exists.
  };

  //Write this to firebase. Return a status and resulting payload to the client.
  let user = window.firebase.auth().currentUser;
  if (user) {
    window.firebase.database().ref(`users/client_${user.uid}`).child('battleRecord').update(newRecord).then(function () {
      callback({
        status: "user-record-updated",
        payload: newRecord
      })
    });
  } else {
    //User not logged in. Return a modified submission anyway, but note that it won't be saved.
    callback({
      status: "user-not-logged-in",
      payload: newRecord
    })
  }
}

//Quick tool for generating the correct key of userRecordsSchema model to edit
function getEditingRecordKey(winOrLose, battleType) {

  let end = "unknown";
  if (winOrLose === "win") {
    end = "BattleWins"
  }
  if (winOrLose === "lose") {
    end = "BattleLosses"
  }

  return battleType + end;

}



export async function addAcquisitionTypeToUser(userId) {

  //Get the user from Firebase
  const userRef = window.firebase.database().ref(`users/client_${userId}`);
  const userDataSnapshot = await userRef.once("value");
  const userData = userDataSnapshot.val();

  //If user already has an aquisition model, bail here. Never want to override this!
  if (userData["acquisitionModel"]) {
    return
  }

  //Otherwise, we know we need an aquisition model.
  const roomInviteId = getQueryVariable("p");

  if (!roomInviteId) {
    //Case 1: No invite link. This person is organic.
    userRef.child("acquisitionModel").set({
      type: "organic"
    });
    return
  }

  //We were invited to a room. We need to know who the room belongs to.
  const roomRef = window.firebase.database().ref(`rooms/${roomInviteId}`);
  const roomDataSnapshot = await roomRef.once("value");
  const roomData = roomDataSnapshot.val();

  //If this room exists & it has a creator, use that!
  if (roomData && roomData.createdByClientId) {
    userRef.child("acquisitionModel").set({
      type: "invite",
      invitedBy: roomData.createdByClientId
    });
    return
  }

  //Otherwise, default to organic.
  userRef.child("acquisitionModel").set({
    type: "organic"
  });

}


// WEBPACK FOOTER //
// ./src/battle/connection/firebase-users.js